import { Checkbox, XStack } from 'tamagui'
import { Check } from '@tamagui/lucide-icons-2'
import { useEditMode } from 'purchasers/editMode'
import { Label } from './label'

interface Props {
    checked?: boolean
    onCheckedChange?: (checked: boolean) => void
    onChange?: (e: any) => void
    label?: string
    disabled?: boolean
    size?: '$2' | '$3' | '$4'
}

export default (props: Props) => {
    const { editMode } = useEditMode()

    const handleChange = (checked: boolean) => {
        if (!editMode) return
        props.onCheckedChange?.(checked)
        props.onChange?.({ target: { checked } })
    }

    return (
        <XStack alignItems="center" gap="$2.5">
            <Checkbox
                checked={props.checked}
                onCheckedChange={handleChange}
                disabled={!editMode || props.disabled}
                size={props.size}
                id={props.label}
                animation="quick"
                borderRadius="$1"
            >
                <Checkbox.Indicator backgroundColor="$primary">
                    <Check size={14} color="white" />
                </Checkbox.Indicator>
            </Checkbox>
            {props.label && (
                <Label htmlFor={props.label} marginBottom={0} width="unset">
                    {props.label}
                </Label>
            )}
        </XStack>
    )
}
